export const environment = {
  production: false,
  api: {
    url: 'https://sso-admin-api-cdt.maersk.io',
    scopes: ['api://6e95ff87-e9db-419b-96d2-2075c37f1d05/access_as_user']
  },
  msal: {
    clientId: 'cc7fdf49-e9bd-46f6-8d33-423f038180e6',
    authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d/v2.0',
    scopes: [
      'openid',
      'profile',
      'email',
      'user.read'
    ]
  }
}
